type StatusPillColor = "green" | "gray"

interface StatusPillProps {
  text: string
  color: StatusPillColor
}

const colorClassByColor: Record<StatusPillColor, string> = {
  green: "text-v2-foreground-success-tonal",
  gray: "color-subtle",
}

export function StatusPill({ text, color }: StatusPillProps) {
  return <span className={`text-body ${colorClassByColor[color]}`}>{text}</span>
}
